<template>
	<div>
		<div class="comp">
			<div class="taskBox" style="width:252px;flex-shrink:0;margin-right: 12px;;">
				<div class="btnBox" :class="curBusiness=='条码'?'active':''" style="width:75px" @click="drawerScanningCodeMsg_state=true;" >
					<img v-if="curBusiness=='条码'" class="btnImg" src="../../../assets/img/mendian/btnImg1_1.png">
					<img v-else class="btnImg" src="../../../assets/img/mendian/btnImg1.png">
					<div class="btnText">查询条码</div>
				</div>
				<div class="btnBox" :class="curBusiness=='活动'?'active':''" style="width:75px" @click="$store.commit('mendian/set_curBusiness','活动')">
					<img v-if="curBusiness=='活动'" class="btnImg" src="../../../assets/img/mendian/btnImg4_1.png">
					<img v-else class="btnImg" src="../../../assets/img/mendian/btnImg4.png">
					<div class="btnText">活动查询</div>
				</div>
				<div class="btnBox" :class="curBusiness=='活体'?'active':''" style="width:75px" @click="$store.commit('mendian/set_curBusiness','活体');$store.commit('living/set_type','list')">
					<img v-if="curBusiness=='活体'" class="btnImg" src="../../../assets/img/mendian/btnImg5_1.png">
					<img v-else class="btnImg" src="../../../assets/img/mendian/btnImg5.png">
					<div class="btnText">活体商城</div>
				</div>
			</div>
			<div class="taskBox" style="width:90%;padding-right: 12px;" >
				<div class="btnBox" :class="curBusiness=='消费'?'active':''" @click="changeBusiness('消费')" style="margin-right: 12px;">
					<img v-if="curBusiness=='消费'" class="btnImg" src="../../../assets/img/mendian/btnImg8_1.png">
					<img v-else class="btnImg" src="../../../assets/img/mendian/btnImg8.png">
					<div class="btnText">消费</div>
				</div>
				<div class="btnBox" :class="curBusiness==='充值'?'active':''" @click="changeBusiness('充值');$store.commit('recharge/set_type','add')" style="margin-right: 12px;">
					<img v-if="curBusiness=='充值'" class="btnImg" src="../../../assets/img/mendian/btnImg2_1.png">
					<img v-else class="btnImg" src="../../../assets/img/mendian/btnImg2.png">
					<div class="btnText">充值</div>
				</div>
				<div class="btnBox" :class="curBusiness=='洗美'?'active':''" @click="changeBusiness('洗美')" style="margin-right: 12px;">
					<img v-if="curBusiness=='洗美'" class="btnImg" src="../../../assets/img/mendian/btnImg7_1.png">
					<img v-else class="btnImg" src="../../../assets/img/mendian/btnImg7.png">
					<div class="btnText">洗美</div>
				</div>
				<div class="btnBox" :class="curBusiness=='寄养'?'active':''" @click="changeBusiness('寄养')" style="margin-right: 12px;">
					<img v-if="curBusiness=='寄养'" class="btnImg" src="../../../assets/img/mendian/btnImg6_1.png">
					<img v-else class="btnImg" src="../../../assets/img/mendian/btnImg6.png">
					<div class="btnText">寄养</div>
				</div>
				<div class="btnBox" :class="curBusiness=='挂号'?'active':''" @click="changeBusiness('挂号')" style="margin-right: 12px;">
					<img v-if="curBusiness=='挂号'" class="btnImg" src="../../../assets/img/mendian/btnImg3_1.png">
					<img v-else class="btnImg" src="../../../assets/img/mendian/btnImg3.png">
					<div class="btnText">挂号</div>
				</div>
				<div class="btnBox" :class="curBusiness=='免疫'?'active':''" @click="changeBusiness('免疫');$store.commit('ymqc/set_type','add')">
					<img v-if="curBusiness=='免疫'" class="btnImg" src="../../../assets/img/mendian/btnImg9_1.png">
					<img v-else class="btnImg" src="../../../assets/img/mendian/btnImg9.png">
					<div class="btnText">免疫</div>
				</div>
			</div>
			<div class="task1Box" style="width:100%;" >
				<div class="btn1Box" :class="curBusiness=='接待'?'active':''" @click="changeBusiness('接待')">
					<div class="btn1Num">
						{{$public.jia(jiedaiLength.order,0)}}
					</div>
					<div class="btn1Text">
						接待列表
						<img v-if="curBusiness!=='接待'" class="btn1Img" src="../../../assets/img/mendian/next1.png"/>
					</div>
				</div>
				<div class="btn1Box" :class="curBusiness=='跟进'?'active':''" @click="changeBusiness('跟进')">
					<div class="btn1Num">
						{{waitCount.followCount}}
					</div>
					<div class="btn1Text">
						待跟进客户
						<img v-if="curBusiness!=='跟进'" class="btn1Img" src="../../../assets/img/mendian/next1.png"/>
					</div>
				</div>
				<!-- 端口8010 没有接口 -->
				<!-- <div class="btn1Box" :class="curBusiness=='预约'?'active':''" @click="changeBusiness('预约')">
					<div class="btn1Num">
						{{waitCount.reservationCount}}
					</div>
					<div class="btn1Text">
						待受理预约
						<img v-if="curBusiness!=='预约'" class="btn1Img" src="../../../assets/img/mendian/next1.png"/>
					</div>
				</div> -->
				<div class="btn1Box" :class="curBusiness=='调拨单'?'active':''" @click="changeBusiness('调拨单')">
					<div class="btn1Num">
						{{waitCount.procureCount}}
					</div>
					<div class="btn1Text">
						<!-- 待验收调拨单 -->
						待收货
						<img v-if="curBusiness!=='调拨单'" class="btn1Img" src="../../../assets/img/mendian/next1.png"/>
					</div>
				</div>
				<div class="btn1Box" :class="curBusiness=='2小时'?'active':''" @click="changeBusiness('2小时')">
					<div class="btn1Num">
						{{waitCount.orderCount}}
					</div>
					<div class="btn1Text">
						超时订单
						<img v-if="curBusiness!=='2小时'" class="btn1Img" src="../../../assets/img/mendian/next1.png"/>
					</div>
				</div>
			</div>
		</div>
		<drawerScanningCodeMsg v-if="drawerScanningCodeMsg_state" @close="submit_drawer_scanningCodeMsg"></drawerScanningCodeMsg>
	</div>
</template>
<script>
	import drawerScanningCodeMsg from '../../../components/drawer/drawer_scanningCodeMsg.vue'
	export default {
		components:{drawerScanningCodeMsg},
		data(){
			return{
				// 查询条码信息
				drawerScanningCodeMsg_state:false,
				// 计时器
				interval1:null,
			}
		},
		computed:{
			isSanke(){
				return this.$store.state.mendian.isSanke;
			},
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			saleList(){
				return this.$store.state.mendian.saleList;
			},
			waitCount(){
				return this.$store.state.mendian.waitCount
			},
			curBusiness(){
				return this.$store.state.mendian.curBusiness;
			},
			jiedaiLength(){
				return this.$store.state.mendian.jiedaiLength;
			},
		},
		mounted(){
			this.$store.dispatch('mendian/getWaitCount')
			this.interval1 = setInterval(()=>{
				this.$store.dispatch('mendian/getWaitCount')
			},5*60*1000)
			this.$store.dispatch('mendian/getJiedaiLength')
		},
		methods: {
			changeBusiness(str){
				if(str==='充值'||str==='洗美'||str==='寄养'||str==='挂号'||str==='免疫'){
					if(this.$public.isNull(this.userInfo._id)){
						this.$message({
							message: '请选择顾客',
							type: 'error'
						});
						return 
					}
					if(this.userInfo._id==='sankeId'){
						this.$message({
							message: '散客不可以使用此功能',
							type: 'error'
						});
						return 
					}
				}
				this.$store.commit('mendian/set_curBusiness',str)
			},
			submit_drawer_scanningCodeMsg(){
				this.drawerScanningCodeMsg_state = false;
			}
		},
		destroyed(){
			clearInterval(this.interval1)
		}
	}
</script>
<style scoped lang="scss">
.comp{
	height: 60px;display: flex;width:100%;
	.taskBox{
		display: flex;justify-content: space-between;
		.btnBox{
			text-align: center;background-color: #fff;border-radius: 4px;width:100%;cursor: pointer;color:$fontColor;
			// &:hover{
			// 	background-color: $mainColor;color:#fff;
			// }
			&.active{
				background-color: $mainColor;color:#fff;
			}
			.btnImg{
				height: 30px;padding:5px 0 3px;
			}
			.btnText{
				font-size: 12px;
			}
		}
	}
	.task1Box{
		display: flex;border-radius: 4px;overflow: hidden;
		.btn1Box{
			text-align: center;background-color: #fff;width:100%;cursor: pointer;color:#333;
			// &:hover{
			// 	background-color: $mainColor;color:#fff;
			// 	.btn1Num{
			// 		color:#fff;
			// 	}
			// }
			&.active{
				background-color: $mainColor;color:#fff;
				.btn1Num{
					color:#fff;
				}
			}
			.btn1Num{
				font-size: 14px;color: $mainColor;padding:12px 0;font-weight: bold;
			}
			.btn1Text{
				font-size: 12px;
				.btn1Img{
					width:18px;vertical-align: middle;margin-top:-2px;margin-left:-4px;
				}
			}
		}
	}
}
</style>
